import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/pipes/pipes.module';
import { UsernameComponent } from '../username/username.component';

@Component({
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, UsernameComponent, PipesModule, RouterModule],
  selector: 'message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {

  text = '';
  author: string = null;
  date: Date = new Date();
  showDeleteButton = false;

  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  @Input('author')
  set setAuthor(author: string) {
    this.author = author;
  }

  @Input('text')
  set setWallImage(text: string) {
    this.text = text;
  }

  @Input('date')
  set setDate(date: Date) {
    this.date = date;
  }

  @Input('showDeleteButton')
  set setShowDeleteButton(show: boolean) {
    this.showDeleteButton = show;
  }

  constructor() {
  }

  ngOnInit() {
  }

}
